var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialShareLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 21.6004V14.5684C21.5999 11.1124 20.8559 8.47239 16.8239 8.47239C14.8799 8.47239 13.5839 9.52839 13.0559 10.5364H13.0079V8.78439H9.1919V21.6004H13.1759V15.2404C13.1759 13.5604 13.4879 11.9524 15.5519 11.9524C17.5919 11.9524 17.6159 13.8484 17.6159 15.3364V21.5764H21.5999V21.6004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7119 8.78439H6.6959V21.6004H2.7119V8.78439Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7039 2.40039C3.4319 2.40039 2.3999 3.43239 2.3999 4.70439C2.3999 5.97639 3.4319 7.03239 4.7039 7.03239C5.9759 7.03239 7.0079 5.97639 7.0079 4.70439C7.0079 3.43239 5.9759 2.40039 4.7039 2.40039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialShareLinkedin);
export default __webpack_public_path__ + "static/media/social-share-linkedin.2eaff2358382b15d24af7b1350572ff6.svg";
export { ForwardRef as ReactComponent };